/**
 * Substack subscribe widget embed.
 * Renders the official Substack iframe inside a dark-themed card.
 */
export default function SubstackEmbed({
  publicationSubdomain = "cjavory",
  height = 320,
  testId = "substack-embed",
}) {
  const src = `https://${publicationSubdomain}.substack.com/embed`;
  return (
    <div
      data-testid={testId}
      className="relative border border-[#262626] bg-[#0e0e0e] p-4 w-full max-w-md"
    >
      <div className="flex items-center justify-between mb-3">
        <span className="overline overline-red">Join the Newsletter</span>
        <span className="font-mono text-[10px] text-white/35">SUBSTACK</span>
      </div>
      <div className="bg-white" style={{ height }}>
        <iframe
          title="Subscribe to The Decision Margin on Substack"
          src={src}
          width="100%"
          height={height}
          style={{ border: 0, background: "white", display: "block" }}
          frameBorder="0"
          scrolling="no"
        />
      </div>
    </div>
  );
}
